import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "m-auto px-8 md:px-20 pb-5" }
const _hoisted_2 = { class: "max-w-screen-2xl m-auto" }
const _hoisted_3 = { class: "font-bold" }
const _hoisted_4 = { class: "grid grid-cols-3 gap-3 my-3" }
const _hoisted_5 = { class: "flex flex-col mb-3" }
const _hoisted_6 = { class: "flex flex-col mb-3" }
const _hoisted_7 = { class: "flex flex-col mb-3" }
const _hoisted_8 = { class: "col-start-1 flex flex-col" }
const _hoisted_9 = { class: "border text-xs border-next-dark-gray px-2 rounded-sm mr-2" }
const _hoisted_10 = { class: "text-sm border rounded-sm p-1" }
const _hoisted_11 = { class: "ml-2" }
const _hoisted_12 = { class: "flex flex-col mb-3" }
const _hoisted_13 = { class: "flex flex-col mb-3" }
const _hoisted_14 = { class: "my-3 col-span-3" }
const _hoisted_15 = { class: "flex flex-col" }
const _hoisted_16 = { class: "flex flex-col" }
const _hoisted_17 = { class: "flex flex-col" }
const _hoisted_18 = { class: "flex items-center" }
const _hoisted_19 = { class: "flex justify-end" }
const _hoisted_20 = { class: "" }
const _hoisted_21 = { class: "p-3 bg-white rounded-lg shadow" }
const _hoisted_22 = { class: "flex pt-3 justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!
  const _component_MultiselectOption = _resolveComponent("MultiselectOption")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_NextButton = _resolveComponent("NextButton")!
  const _component_draggable = _resolveComponent("draggable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[16] || (_cache[16] = _createElementVNode("div", { id: "selectModal" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[15] || (_cache[15] = _createElementVNode("div", { class: "py-5 text-2xl font-bold" }, " Dettaglio business unit ", -1)),
      _withDirectives(_createElementVNode("div", {
        class: _normalizeClass([[_ctx.esito ? 'bg-next-bri' : 'bg-next-orange'], "text-white p-3 mb-3 flex justify-between items-center"])
      }, [
        _createTextVNode(_toDisplayString(_ctx.response_message) + " ", 1),
        _createElementVNode("i", {
          class: "icon-x cursor-pointer",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.response_message = ''))
        })
      ], 2), [
        [_vShow, _ctx.response_message.length]
      ]),
      _createElementVNode("p", null, [
        _cache[7] || (_cache[7] = _createTextVNode("Business unit: ")),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.bu.nome), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Field, {
            field_name: "Nome",
            modelValue: _ctx.bu.nome,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.bu.nome) = $event)),
            errors: _ctx.getErrors('nome')
          }, null, 8, ["modelValue", "errors"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Field, {
            field_name: "Etichetta",
            modelValue: _ctx.bu.label,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.bu.label) = $event)),
            errors: _ctx.getErrors('label')
          }, null, 8, ["modelValue", "errors"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_Field, { field_name: "Utente controllore" }, {
            default: _withCtx(() => [
              _createVNode(_component_VueMultiselect, {
                modelValue: _ctx.userAutocomplete.selection,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.userAutocomplete.selection) = $event)),
                options: _ctx.userAutocomplete.options,
                placeholder: "Utente controllore",
                class: "next-vue-multiselect-single",
                "track-by": "id",
                label: "name",
                selectLabel: "",
                deselectLabel: "",
                selectedLabel: "",
                "internal-search": false,
                onSearchChange: _ctx.userAutocomplete.search
              }, null, 8, ["modelValue", "options", "onSearchChange"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_Field, { field_name: "Utenti boards" }, {
            default: _withCtx(() => [
              _createVNode(_component_VueMultiselect, {
                searchable: true,
                loading: _ctx.boardsAutocomplete.isLoading,
                "internal-search": false,
                trackBy: "id",
                label: "nome",
                onSearchChange: _ctx.boardsAutocomplete.search,
                modelValue: _ctx.boardsAutocomplete.selection,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.boardsAutocomplete.selection) = $event)),
                options: _ctx.boardsAutocomplete.options,
                multiple: true,
                "close-on-select": false,
                "clear-on-select": false,
                class: "next-vue-multiselect",
                placeholder: "Board",
                deselectLabel: "Deseleziona",
                selectedLabel: "Selezionato",
                selectLabel: "Seleziona"
              }, {
                noResult: _withCtx(() => _cache[8] || (_cache[8] = [
                  _createTextVNode("Nessun elemento trovato.")
                ])),
                noOptions: _withCtx(() => _cache[9] || (_cache[9] = [
                  _createTextVNode("Digita per cercare")
                ])),
                tag: _withCtx(({option, remove}) => [
                  _createVNode(_component_MultiselectOption, {
                    onRemove: ($event: any) => (remove(option))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_9, _toDisplayString(option.bu_label || ' '), 1),
                      _createElementVNode("span", null, _toDisplayString(option.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["onRemove"])
                ]),
                option: _withCtx(({option}) => [
                  _createElementVNode("span", null, [
                    _createElementVNode("span", _hoisted_10, _toDisplayString(option.bu_label), 1),
                    _createElementVNode("span", _hoisted_11, _toDisplayString(option.name), 1)
                  ])
                ]),
                _: 1
              }, 8, ["loading", "onSearchChange", "modelValue", "options"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_Field, {
            field_name: "Visibile crm",
            errors: _ctx.getErrors('show_crm')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Checkbox, {
                checked: _ctx.bu.show_crm,
                onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.bu.show_crm = !_ctx.bu.show_crm)),
                checkClass: "w-4 h-4"
              }, null, 8, ["checked"])
            ]),
            _: 1
          }, 8, ["errors"])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_Field, {
            field_name: "Visibile progetti",
            errors: _ctx.getErrors('show_progetti')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Checkbox, {
                checked: _ctx.bu.show_progetti,
                onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.bu.show_progetti = !_ctx.bu.show_progetti)),
                checkClass: "w-4 h-4"
              }, null, 8, ["checked"])
            ]),
            _: 1
          }, 8, ["errors"])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _cache[12] || (_cache[12] = _createElementVNode("div", { class: "font-bold pb-2 text-sm" }, "Fasce di ricavo", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fasce, (fascia, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: i,
              class: "grid grid-cols-[repeat(3,_minmax(0,_1fr))_max-content] gap-4 mb-3"
            }, [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_Field, {
                  "label-visible": false,
                  placeholder: "Descrizione",
                  errors: _ctx.getErrorsFasce(i, 'descrizione'),
                  modelValue: fascia.descrizione,
                  "onUpdate:modelValue": ($event: any) => ((fascia.descrizione) = $event)
                }, null, 8, ["errors", "modelValue", "onUpdate:modelValue"])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_Field, {
                  "label-visible": false,
                  placeholder: "Minimo",
                  errors: _ctx.getErrorsFasce(i, 'min'),
                  inputAttrs: {min:0,step:'0.01'},
                  modelValue: fascia.min,
                  "onUpdate:modelValue": ($event: any) => ((fascia.min) = $event),
                  type: "number"
                }, null, 8, ["errors", "modelValue", "onUpdate:modelValue"])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_Field, {
                  "label-visible": false,
                  placeholder: "Massimo",
                  errors: _ctx.getErrorsFasce(i, 'max'),
                  inputAttrs: {min:0,step:'0.01'},
                  modelValue: fascia.max,
                  "onUpdate:modelValue": ($event: any) => ((fascia.max) = $event),
                  type: "number"
                }, null, 8, ["errors", "modelValue", "onUpdate:modelValue"])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_NextButton, {
                  variant: "outline-secondary",
                  onClick: ($event: any) => (_ctx.removeFasce(i)),
                  class: "col flex justify-center items-center h-8 w-8"
                }, {
                  default: _withCtx(() => _cache[10] || (_cache[10] = [
                    _createElementVNode("i", { class: "icon-x" }, null, -1)
                  ])),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_NextButton, {
              variant: "primary",
              onClick: _ctx.addFascia,
              class: "col flex justify-center items-center h-8 w-8"
            }, {
              default: _withCtx(() => _cache[11] || (_cache[11] = [
                _createElementVNode("i", { class: "icon-croce_quadrata" }, null, -1)
              ])),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _cache[13] || (_cache[13] = _createElementVNode("h3", { class: "font-bold text-center mb-2" }, "Lista campi preventivo", -1)),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_draggable, {
              class: "divide-y-2 divide-gray-100",
              list: _ctx.campi_preventivo,
              group: "colonne",
              onChange: _ctx.log,
              itemKey: "name"
            }, {
              item: _withCtx(({ element, index }) => [
                _createElementVNode("div", {
                  class: _normalizeClass(["p-1 flex justify-between", _ctx.getColor(element[0])])
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.getDescription(element[0])), 1),
                  _createVNode(_component_Checkbox, {
                    checked: element[1],
                    onChange: ($event: any) => (element[1] = !element[1]),
                    checkClass: "w-4 h-4"
                  }, null, 8, ["checked", "onChange"])
                ], 2)
              ]),
              _: 1
            }, 8, ["list", "onChange"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createVNode(_component_NextButton, {
          class: "px-3 py-2",
          onClick: _ctx.save
        }, {
          default: _withCtx(() => _cache[14] || (_cache[14] = [
            _createTextVNode("Salva")
          ])),
          _: 1
        }, 8, ["onClick"])
      ])
    ])
  ]))
}